import { logConsole } from "./useConsole"

export const clearDB = () => {
    logConsole({ message: "Platform not supported! << you switched account" });
    localStorage.clear()
}